import React from 'react';
import { path, sortWith, descend, compose } from 'ramda';

import HistoryEntry from 'components/HistoryEntry';
import HistoryEntryHeader from 'components/HistoryEntryHeader';
import HistoryEntryColumns from 'components/HistoryEntryColumns';
import HistoryEntryColumn from 'components/HistoryEntryColumn';
import CommonHistoryEntryControls from 'routes/Documents/components/CommonHistoryEntryControls';
import CommonViewButton from 'routes/Documents/components/CommonViewButton';
import { getLatestFinishedCommitData } from 'lib/documentHandling';

import { formatHeaderDate, editTimeLeft, dateValue } from 'lib/dateDisplay';

export const sorter = sortWith([descend(compose(dateValue, path(['createDate'])))]);

const msg = id => ({ id });

const renderEntryHeader = (doc, fm) => `${formatHeaderDate(doc.createDate)}`;

const renderHeader = m => <p children={m} />;

const historyMapper =
  (name, edit, view) =>
  (d, { formatMessage }) => (
    <HistoryEntry key={d.documentId}>
      <HistoryEntryHeader title={renderEntryHeader(d, formatMessage)} active={editTimeLeft(d.createDate)}>
        {window.__ROLE__ !== 'DOCTOR' && editTimeLeft(d.createDate) && (
          <CommonHistoryEntryControls
            time={d.createDate}
            action={() => edit(name, d.documentId, getLatestFinishedCommitData(d))}
          />
        )}
        {(window.__ROLE__ === 'DOCTOR' || !editTimeLeft(d.createDate)) && (
          <CommonViewButton onView={e => view('msis', d.documentId)} />
        )}
      </HistoryEntryHeader>
      <HistoryEntryColumns>
        <HistoryEntryColumn header={renderHeader(formatMessage(msg('msis.labels.filled')))} smallScaling={6}>
          <p>{d.filled + ' / 29'}</p>
        </HistoryEntryColumn>
        <HistoryEntryColumn header={renderHeader(formatMessage(msg('msis.labels.scoreTotal')))} smallScaling={6}>
          <p>{d.scores.physical + d.scores.mental}</p>
        </HistoryEntryColumn>
        <HistoryEntryColumn header={renderHeader(formatMessage(msg('msis.labels.scorePhysical')))} smallScaling={6}>
          <p>{d.scores.physical}</p>
        </HistoryEntryColumn>
        <HistoryEntryColumn header={renderHeader(formatMessage(msg('msis.labels.scoreMental')))} smallScaling={6}>
          <p>{d.scores.mental}</p>
        </HistoryEntryColumn>
      </HistoryEntryColumns>
    </HistoryEntry>
  );

export default historyMapper;
